import React from 'react';

const Arrow = ({mainColor}) => {
	return (
		<svg version="1.1" id="arrow_svg"
		     xmlns="http://www.w3.org/2000/svg"
		     x="0px" y="0px"
		     width="110px" height="110px"
		     viewBox="0 0 110 110">
			<g>
				<path fill={mainColor} d="M33.07,53.46l38.31-36.51c0.64-0.61,1.49-0.95,2.37-0.95c0.88,0,1.73,0.34,2.37,0.95l0.04,0.04
		c0.31,0.3,0.56,0.65,0.73,1.04c0.17,0.39,0.26,0.82,0.26,1.25c0,0.43-0.09,0.85-0.26,1.25c-0.17,0.39-0.42,0.75-0.73,1.04
		L40.09,55.95l36.08,34.36c0.31,0.29,0.56,0.65,0.73,1.04c0.17,0.39,0.26,0.82,0.26,1.25c0,0.43-0.09,0.85-0.26,1.25
		c-0.17,0.39-0.42,0.75-0.73,1.04l-0.04,0.04c-0.64,0.61-1.49,0.95-2.37,0.95c-0.88,0-1.73-0.34-2.37-0.95L33.07,58.43
		c-0.34-0.32-0.61-0.71-0.79-1.13S32,56.41,32,55.94c0-0.47,0.09-0.93,0.28-1.35S32.73,53.78,33.07,53.46z"/>
			</g>
		</svg>
	);
};

export default Arrow;